var React = require('react');

function GlobeInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9 15.75a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5ZM2.635 6.75h12.73M2.635 11.25h12.73","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9 15.569c1.553 0 2.813-2.941 2.813-6.569S10.553 2.431 9 2.431C7.447 2.431 6.187 5.372 6.187 9S7.447 15.569 9 15.569Z","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

GlobeInline.defaultProps = {"width":"18","height":"18","fill":"none"};

module.exports = GlobeInline;

GlobeInline.default = GlobeInline;
